//страница "Документы склада"
import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Input, Button, Table, Switch, Popconfirm, message, Space, DatePicker} from "antd";
import { DeleteOutlined, SearchOutlined } from "@ant-design/icons";

import axios from "axios";

import { CreateDocsWarehouse } from "src/features/Modal";
import { EditDocsWarehouse } from "src/features/Modal";
import { apiRequests } from "src/shared/api/api";
import { PhotoUploadModal } from "src/features/Modal";


const { RangePicker } = DatePicker;

const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({ title, editable, children, dataIndex, record, handleSave, ...restProps }) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.log("Save failed:", errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{
          margin: 0,
        }}
        name={dataIndex}
        rules={[
          {
            required: true,
            message: `${title} обязательно для ввода.`,
          },
        ]}>
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          paddingRight: 24,
        }}
        onClick={toggleEdit}>
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};

class DocsWarehouse extends React.Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        title: "Номер",
        dataIndex: "number",
        key: "number",
        editable: false,
      },
      {
        title: "От даты",
        key: "dated",
        dataIndex: "dated",
        editable: false,
        render: (date) => {
          const dateFormat = new Date(date * 1000);
          return `
                    ${dateFormat.getDate()}.${dateFormat.getMonth() + 1}.${dateFormat.getFullYear()}
                    ${dateFormat.getHours()}:${dateFormat.getMinutes()}:${dateFormat.getSeconds()}
                    `;
        },
      },
      {
        title: "Статус",
        key: "status",
        dataIndex: "status",
        editable: false,
        render: (checked, row) => {
          return (
            <Switch
              style={{ marginLeft: "13px" }}
              checked={checked}
              onClick={(checked) => this.handleChangeStatus(checked, row)}
            />
          );
        },
      },
      {
        title: "Операция",
        key: "operation",
        dataIndex: "operation",
        editable: false,
        render: (operation) => {
          if (operation === "incoming") {
            return <font style={{ color: "green" }}>Приходная</font>;
          }
          if (operation === "outgoing") {
            return <font style={{ color: "red" }}>Расходная</font>;
          }
          if (operation === "transfer") {
            return <font style={{ color: "blue" }}>Перемещение</font>;
          }
          if (operation === 'write_off') {
            return <font style={{ color: "red" }}>Списание</font>;
          }
        },
      },
      {
        title: "Сумма",
        key: "sum",
        dataIndex: "sum",
        editable: false,
      },
      {
        title: "Комментарий",
        key: "comment",
        dataIndex: "comment",
        editable: false,
      },
      {
        title: "Организация",
        key: "organization",
        dataIndex: "organization",
        editable: false,
        render: (organization) => {
          const findedOrganization = this.props.organizationsData?.find((item) => item.id === organization);
          return findedOrganization?.full_name;
        },
      },
      {
        title: "Склад",
        key: "warehouse",
        dataIndex: "warehouse",
        editable: false,
        render: (warehouse) => {
          const findedWarehouse = this.props.warehousesData.find((item) => item.id === warehouse);
          return findedWarehouse?.name;
        },
      },
    ];

    this.columns.push({
      title: "Действие",
      key: "action",
      width: 160,
      render: (_, record) => {
        return this.state.dataSource.length >= 1 ? (
          <>
            <Popconfirm
              title="Подтвердите удаление"
              onConfirm={() => this.handleDelete(record.id)}
              cancelText="Отмена"
              okText="OK">
              <Button icon={<DeleteOutlined />} style={{ marginRight: 10 }} />
            </Popconfirm>
            <EditDocsWarehouse
              doc={record}
              token={this.props.query.token}
              updateRow={this.updateRow}
              tags={this.props.tags}
            />
          </>
        ) : (
          "Загрузка..."
        );
      },
    });

    this.state = {
      count: this.props.c,
      dataSource: this.props.ds,
      loading: true,
      currentPage: 1,
      datesFilter: [],
      require_photo_for_writeoff: false,
      showPhotoModal: false,
      photoFiles: [],         // controlled fileList for Upload + preview info
      realFiles: [],          // actual File objects for upload
      photoUploading: false,
      currentDocIdForPhoto: null,
    };
  }

  getStamps = (datesArr) => {
    if (datesArr) {
      let datefrom = datesArr[0].startOf("day").unix();
      let dateto = datesArr[1].startOf("day").unix();

      this.setState({ datesFilter: [datefrom, dateto] });
    } else {
      this.setState({ datesFilter: [] });
      this.fetch(1, `https://${process.env.REACT_APP_APP_URL}/api/v1/docs_warehouse/`, false);
    }
  };

  find = () => {
    this.fetch(1, `https://${process.env.REACT_APP_APP_URL}/api/v1/docs_warehouse/`);
  };

  findRun = () => {
    this.setState({ loading: true });

    let params = { token: this.props.query.token, offset: 0, limit: 100000 };
    let dates = {};

    if (this.state.datesFilter.length > 0) {
      dates["datefrom"] = this.state.datesFilter[0];
      dates["dateto"] = this.state.datesFilter[1];
    }

    apiRequests.docs.warehouse(Object.assign({}, params, dates)).then((res) => {
      let statusesArr = [];
      for (let elem of res.data.result) {
        statusesArr.push({ id: elem.id, status: true });
      }
      apiRequests.altDocs.patchWarehouse(statusesArr).then((res) => {
        this.setState({ loading: false });
        message.info("Вы провели документы за промежуток!");
      });
    });
  };

  componentDidMount() {
    this.fetchRequirePhotoSetting();
    this.fetch(1, `https://${process.env.REACT_APP_APP_URL}/api/v1/docs_warehouse/`);
    const { websocket } = this.props;

    websocket.onmessage = (message) => {
      const data = JSON.parse(message.data);

      if (data.target === "docs_warehouse") {
        if (data.action === "create") {
          data.result.forEach((docs_sale) => {
            if (
              this.props.tags === undefined ||
              (this.props.tags !== undefined && docs_sale.tags === this.props.tags)
            ) {
              if (this.state.currentPage === 1) {
                const DS = [...this.state.dataSource];
                const C = this.state.count;
                if (DS.length <= 34) {
                  DS.unshift(docs_sale);
                } else {
                  DS.pop();
                  DS.unshift(docs_sale);
                }
                this.setState({ dataSource: DS, count: C + 1 });
              }
            }
          });
        }

        if (data.action === "edit") {
          data.result.forEach((docs_sale) => {
            const newData = [...this.state.dataSource];
            const index = newData.findIndex((item) => docs_sale.id === item.id);

            if (index !== -1) {
              const item = newData[index];
              newData.splice(index, 1, { ...item, ...docs_sale });
              this.setState({ dataSource: newData });
            }
          });
        }

        if (data.action === "delete") {
          data.result.forEach((docs_sale) => {
            const newData = [...this.state.dataSource];
            const index = newData.findIndex((item) => docs_sale === item.id);

            if (index !== -1) {
              newData.splice(index, 1);
              this.setState({ dataSource: newData });
            }
          });
        }
      }
    };
  }

  fetchRequirePhotoSetting = async () => {
    try {
      const res = await fetch(
        `https://${process.env.REACT_APP_APP_URL}/api/v1/cashbox/settings?token=${this.props.query.token}`
      );
      if (res.ok) {
        const data = await res.json();
        this.setState({ require_photo_for_writeoff: data.require_photo_for_writeoff });
      }
    } catch (e) {
      console.error("Failed to fetch photo setting:", e);
    }
  };

  handleChangeStatus = async (status, row) => {
    const { require_photo_for_writeoff } = this.state;

    if (row.operation === "write_off" && status && require_photo_for_writeoff) {
      // Step 1: Check if photos already exist for this document
      const params = {
        token: this.props.query.token,
        entity: "docs_warehouse",
        entity_id: row.id,
      };

      try {
        const response = await axios.get(
          `https://${process.env.REACT_APP_APP_URL}/api/v1/pictures/`,
          { params }
        );

        if (response.data.result.length > 0) {
          // Photos exist — allow status update
          this.updateStatus(row.id, status);
        } else {
          // No photos — show modal
          this.setState({
            showPhotoModal: true,
            currentDocIdForPhoto: row.id,
            photoUploading: false,
            photoFiles: [],
            realFiles: [],
          });
        }
      } catch (error) {
        console.error("Error checking for existing photos:", error);

        // Fallback: Assume no photos and show modal
        message.warning("Не удалось проверить фото. Пожалуйста, прикрепите фото.");
        this.setState({
          showPhotoModal: true,
          currentDocIdForPhoto: row.id,
          photoUploading: false,
          photoFiles: [],
          realFiles: [],
        });
      }
    } else {
      // Proceed normally if no photo requirement or not a write_off
      this.updateStatus(row.id, status);
    }
  };

  updateStatus = (id, status) => {
    this.setState({ loading: true });
    this.edit_request(id, this.getRowById(id), { status: status });
  };

  getRowById = (id) => {
    return this.state.dataSource.find((item) => item.id === id);
  };

  // ---------- Upload handlers (вариант A: кастомный список, контролируемый Upload) ----------
  handlePhotoUpload = ({ fileList }) => {
    // Приводим fileList к безопасному виду: uid, originFileObj, preview
    const safeFileList = fileList.map((file) => {
      if (!file.uid) file.uid = `${Date.now()}_${Math.random()}`;

      // originFileObj может быть undefined если файл был получен с сервера — используем сам объект
      const origin = file.originFileObj || file;

      // создаём preview только для локальных File объектов
      if (!file.preview && origin && origin instanceof File) {
        try {
          file.preview = URL.createObjectURL(origin);
        } catch (e) {
          file.preview = null;
        }
      }

      // гарантируем наличие originFileObj для отправки
      file.originFileObj = origin;

      return file;
    });

    this.setState({
      photoFiles: safeFileList,
      realFiles: safeFileList.map((f) => f.originFileObj).filter(Boolean),
    });
  };

  handleRemovePhoto = (fileUid) => {
    const { photoFiles } = this.state;
    const fileToRemove = photoFiles.find((f) => f.uid === fileUid);

    if (fileToRemove && fileToRemove.preview) {
      try {
        URL.revokeObjectURL(fileToRemove.preview);
      } catch (e) {}
    }

    const newFiles = photoFiles.filter((f) => f.uid !== fileUid);
    this.setState({
      photoFiles: newFiles,
      realFiles: newFiles.map((f) => f.originFileObj).filter(Boolean),
    });
  };

  handlePhotoModalCancel = () => {
    const { photoFiles } = this.state;
    photoFiles.forEach((f) => {
      if (f && f.preview) {
        try {
          URL.revokeObjectURL(f.preview);
        } catch (e) {}
      }
    });

    this.setState({
      showPhotoModal: false,
      photoFiles: [],
      realFiles: [],
      currentDocIdForPhoto: null,
      photoUploading: false,
    });
  };

  handlePhotoModalOk = async () => {
    const { currentDocIdForPhoto, realFiles = [] } = this.state;

    if (!currentDocIdForPhoto) {
      message.error("Не задан id документа для прикрепления фото.");
      console.error("handlePhotoModalOk: currentDocIdForPhoto is undefined");
      return;
    }

    if (!realFiles.length) {
      message.warning("Вы не выбрали фото для загрузки.");
      return;
    }

    this.setState({ photoUploading: true });

    try {
      // Отправляем каждый файл отдельным запросом (т.к. бэкенд в текущей реализации принимает один файл)
      const uploadPromises = realFiles.map(file => {
        const formData = new FormData();
        formData.append("file", file);

        return axios.post(
          `https://${process.env.REACT_APP_APP_URL}/api/v1/pictures/`,
          formData,
          {
            params: {
              token: this.props.query.token,
              entity: "docs_warehouse",
              entity_id: currentDocIdForPhoto,
            },
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      });

      const results = await Promise.allSettled(uploadPromises);

      const failed = results
        .map((r, i) => ({ r, i }))
        .filter(x => x.r.status !== "fulfilled");

      if (failed.length > 0) {
        console.error("Некоторые файлы не загрузились:", failed);
        message.error(`Не удалось загрузить ${failed.length} из ${realFiles.length} фото.`);
      } else {
        message.success("Все фото успешно загружены.");
        try {
          await this.updateStatus(currentDocIdForPhoto, true);
        } catch (e) {
          console.error("Ошибка при обновлении статуса документа:", e);
          message.warning("Фото загружены, но не удалось обновить статус документа.");
        }
        // закрываем модалку и очищаем
        this.setState({
          showPhotoModal: false,
          photoFiles: [],
          realFiles: [],
          currentDocIdForPhoto: null,
        });
      }
    } catch (err) {
      console.error("Ошибка в процессе загрузки фото:", err);
      message.error("Ошибка при загрузке фото. Посмотрите консоль (DevTools).");
    } finally {
      this.setState({ photoUploading: false });
    }
  };

  fetch = (page, url = {}, withDates = true) => {
    const limit = 35;
    const offset = page * 35 - 35;

    let params = { token: this.props.query.token, limit: limit, offset: offset };

    let dates = {};

    if (this.state.datesFilter.length > 0 && withDates) {
      dates["datefrom"] = this.state.datesFilter[0];
      dates["dateto"] = this.state.datesFilter[1];
    }

    if (this.props.tags !== undefined) {
      params.tags = this.props.tags;
    }

    axios.get(url, { params: Object.assign({}, params, dates) }).then((response) => {
      const newData = response.data.result.map((rowData) => ({
        created_at: Date.now(),
        updated_at: Date.now(),
        response_code: 200,
        response: JSON.stringify(rowData, null, 3),
        ...rowData,
      }));

      this.setState({
        count: response.data.count,
        dataSource: newData,
        loading: false,
      });
    });
  };

  handleDelete = (id) => {
    const dataSource = [...this.state.dataSource];
    const row_index = dataSource.findIndex((item) => item.id === id);
    const row = dataSource[row_index];
    dataSource.splice(row_index, 1);

    this.setState({
      dataSource: dataSource,
    });

    apiRequests.docs
      .deleteWarehouse(row.id)
      .then((response) => {
        message.success("Вы успешно удалили документ склада");
      })
      .catch((err) => {
        message.error("Не удалось удалить документ склада!");
        console.log("err", err);
      });
  };

  edit_request = (id, payment, row) => {
    let edit_dict = {};

    for (let item in row) {
      if (row[item] !== payment[item]) {
        edit_dict[item] = row[item];
      }
    }

    edit_dict.id = id;

    if (Object.keys(edit_dict).length !== 0) {
      apiRequests.altDocs.patchWarehouse([edit_dict]).then((res) => {
        this.setState({ loading: false });
      });
    } else {
      message.error(<>Вы не сделали никаких изменений!</>);
    }
  };

  handleSave = (row) => {
    const newData = [...this.state.dataSource];
    const index = newData.findIndex((item) => row.id === item.id);
    const item = newData[index];

    newData.splice(index, 1, { ...item, ...row });

    this.setState({
      dataSource: newData,
    });

    this.edit_request(newData.splice(index, 1, { ...item, ...row })[0]);
  };

  updateRow = (data, response) => {
    const id = data.id || response.data.id;

    const newData = this.state.dataSource;

    newData.forEach((row) => {
      if (row.id === id) {
        row.response_code = response.status;
        row.response = JSON.stringify(response.data, null, 3);
      }
    });

    this.setState({
      dataSource: newData,
    });
  };

  render() {
    const { dataSource } = this.state;
    const components = {
      body: {
        row: EditableRow,
        cell: EditableCell,
      },
    };
    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }

      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });

    return (
      <div>
        <div style={{ marginBottom: 10 }}>
          <CreateDocsWarehouse
            token={this.props.query.token}
            updateRow={this.updateRow}
            tags={this.props.tags}
            phone={this.props.phone}
            name={this.props.name}
          />
          <Space direction="horizontal">
            <RangePicker
              format={"DD.MM.YYYY"}
              placeholder={["Дата начала", "Дата окончания"]}
              style={{ marginLeft: 5 }}
              onChange={(dates) => this.getStamps(dates)}
            />

            <Button onClick={() => this.find()} htmlType="submit" icon={<SearchOutlined />}>
              Найти
            </Button>
            <Button onClick={() => this.findRun()} htmlType="submit" icon={<SearchOutlined />}>
              Найти и провести
            </Button>
          </Space>
        </div>

        <Table
          components={components}
          rowClassName={(record) => record.is_deleted && "disabled-row"}
          rowKey={(record) => record.id}
          bordered
          loading={this.state.loading}
          dataSource={dataSource}
          columns={columns}
          pagination={{
            total: this.state.count,
            onChange: (page) => {
              this.setState(
                { currentPage: page, loading: true },
                this.fetch(page, `https://${process.env.REACT_APP_APP_URL}/api/v1/docs_warehouse/`, false)
              );
            },
            pageSize: 35,
            showSizeChanger: false,
          }}
        />

        <PhotoUploadModal
          open={this.state.showPhotoModal}
          photoFiles={this.state.photoFiles}
          photoUploading={this.state.photoUploading}
          onOk={this.handlePhotoModalOk}
          onCancel={this.handlePhotoModalCancel}
          onUploadChange={this.handlePhotoUpload}
          onRemovePhoto={this.handleRemovePhoto}
        />
      </div>
    );
  }
}

export default DocsWarehouse;
